import { Stack } from '@mantine/core'
import { IdentidadeCard } from './IdentidadeCard'
import { AcessoEfetivoCard } from './AcessoEfetivoCard'
import { SenhaCard } from './SenhaCard'
import { SenhaUnixCard } from './SenhaUnixCard'
import { TotpCard } from './TotpCard'
import { GitlabVinculoCard } from './GitlabVinculoCard'

export function Perfil() {
  return (
    <Stack gap="lg">
      <IdentidadeCard />
      <AcessoEfetivoCard />
      <SenhaCard />
      <SenhaUnixCard />
      <TotpCard />
      <GitlabVinculoCard />
    </Stack>
  )
}
